const api = {
  adid: 'adid'
}

export const adType = {
  payment: 'payment'
}

export function setAddressId (adid) {
  sessionStorage.setItem(api.adid, adid)
}

export function getAddressId () {
  return sessionStorage.getItem('adid')
}

export function setPayInfo (datas) {
  sessionStorage.setItem('payInfo', JSON.stringify(datas))
}

export function getPayInfo () {
  return JSON.parse(sessionStorage.getItem('payInfo'))
}
